export default __webpack_public_path__ + "static/media/Showroom_selected.59ca144b.png";